import React from 'react';
import logo from 'assets/img/logo.png';
import { Schedule } from 'utils/maintenance';

type Props = {
  schedule: Schedule;
}

const Maintenance: React.FC<Props> = (props: Props) => {
  return (
    <React.Fragment>
      <div style={{ textAlign: 'center' }}>
        <div>
          <div>
            <img src={logo} alt="" className="" />
          </div>
          <div style={{ padding: '10px', maxWidth: '800px', margin: '0 auto' }}>
            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>
              現在システムメンテナンス中です
            </p>
            <p style={{ marginBottom: '10px' }}>
              下記の日時におきまして、システムのメンテナンスを実施いたします。
            </p>
            <p>
              【サーバーメンテナンス実施日時】
            </p>
            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>
              { props.schedule.title }
            </p>
            <p>
              【お詫び】システムメンテナンス延長のお知らせ<br />
              現在、システムのメンテナンスを行っておりますが、当初の14時までに終了することができず、誠に申し訳ございませんが、サービス停止時間を延長させていただくこととなりました。<br />
              2025年4月1日（火）午後4:00再開<br />
              現在、迅速にメンテナンス作業を完了させるべく、全力を尽くしております。<br />お客様には大変ご迷惑をおかけいたしますこと、重ねて深くお詫び申し上げます。
              <br /><br />
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Maintenance
